<template>
  <div>
    <el-drawer
      :visible.sync="disableShow"
      v-if="disableShow"
      size="100%"
      direction="rtl"
      :wrapperClosable="false"
      :title="form.id >0 ? '编辑' : '新建'">
      <h3 style="margin: 0 0 15px 15px">货币：{{ coinName(form.instId) }}</h3>
      <el-form class="tradeConfigForm" ref="form" :model="form" label-width="90px" :rules="rules" :show-message="true">
        <div>
          <el-form-item label-width="90px" label="是否启用" prop="is_enable">
            <el-switch v-model="form.is_enable"></el-switch>
          </el-form-item>
          <el-form-item label-width="90px" label="触发模式" prop="trigger_mode"
                        :rules="[{ required: true, message: '触发模式必填', trigger: 'blur' }]">
            <el-select v-model="form.trigger_mode" default-first-option placeholder="请选择">
              <el-option key="1" label="抄底策略A" :value="1"></el-option>
              <el-option key="2" label="抄底策略B" :value="2"></el-option>
              <el-option key="3" label="抄底策略C" :value="3"></el-option>
              <el-option key="4" label="超短线做多" :value="4"></el-option>
            </el-select>
            <el-popover
               style="margin-left: 5px"
              placement="bottom"
              :title="strategyIntroMap[form.trigger_mode]['name']"
              width="300"
              trigger="click">
              <div style="word-break: break-all; white-space: pre-line;">{{strategyIntroMap[form.trigger_mode]['desc']}}</div>
              <el-button icon="el-icon-info" circle size="mini" slot="reference"></el-button>
            </el-popover>
          </el-form-item>
          <el-form-item label-width="90px" label="触发价格" prop="trigger_price"
                        :rules="[{ required: true, message: '触发价格必填', trigger: 'blur' }]">
            <el-input class="U-append" v-model="form.trigger_price" min="1" type="number" placeholder="单位U" clearable>
              <template slot="append">U</template>
            </el-input>
          </el-form-item>
          <el-form-item label-width="90px" label="K线粒度" prop="bar"
                        :rules="[{ required: true, message: 'K线粒度', trigger: 'blur' }]">
            <el-select v-model="form.bar" placeholder="请选择">
              <el-option key="1m" label="1m" value="1m"></el-option>
              <el-option key="3m" label="3m" value="3m"></el-option>
              <el-option key="5m" label="5m" value="5m"></el-option>
              <el-option key="15m" label="15m" value="15m"></el-option>
              <el-option key="30m" label="30m" value="30m"></el-option>
              <el-option key="1H" label="1H" value="1H"></el-option>
              <el-option key="2H" label="2H" value="2H"></el-option>
              <el-option key="4H" label="4H" value="4H"></el-option>
              <el-option key="6H" label="6H" value="6H"></el-option>
              <el-option key="12H" label="12H" value="12H"></el-option>
              <el-option key="1D" label="1D" value="1D"></el-option>
              <el-option key="1W" label="1W" value="1W"></el-option>
              <el-option key="1M" label="1M" value="1M"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="90px" label="K线数" prop="k_limit"
                        :rules="[{ required: true, message: 'K线数', trigger: 'blur' }]">
            <el-input-number v-model="form.k_limit" size="small" :min="1" :max="100" :precision="0" :step="1">
            </el-input-number>
          </el-form-item>
          <el-form-item label-width="90px" label="下单金额" prop="order_amount"
                        :rules="[{ required: true, message: '下单金额必填', trigger: 'blur' }]">
            <el-input-number v-model="form.order_amount" size="small" :min="0.1" :precision="2" :step="5"></el-input-number>
          </el-form-item>
          <el-form-item label-width="90px" label="触发跌幅" prop="trigger_rate"
                        :rules="[{ required: true, message: '触发跌幅必填', trigger: 'blur' }]">
            <el-input-number v-model="form.trigger_rate" size="small" :min="0.1" :max="100" :precision="2" :step="1"></el-input-number>
          </el-form-item>
          <el-form-item label-width="90px" label="止盈点数" prop="pTriggerPx_rate"
                        :rules="[{ required: true, message: '止盈点数必填', trigger: 'blur' }]">
            <el-input-number v-model="form.pTriggerPx_rate" size="small" :min="0.1" :precision="2" :step="1"></el-input-number>
          </el-form-item>
          <el-form-item label-width="90px" label="止损点数" prop="slTriggerPx_rate"
                        :rules="[{ required: true, message: '触发跌幅必填', trigger: 'blur' }]">
            <el-input-number v-model="form.slTriggerPx_rate" size="small" :min="0.1" :max="100" :precision="2" :step="1"></el-input-number>
          </el-form-item>
          <el-form-item label-width="90px" label="触发比率" prop="cur_bar_avg_rate_ratio"
                        :rules="[{ required: true, message: '触发比率', trigger: 'blur' }]">
            <!--                <el-input placeholder="现K线/前N个跌幅均值比" clearable v-model="item.cur_bar_avg_rate_ratio" type="number">-->
            <!--                </el-input>-->
            <el-input-number v-model="form.cur_bar_avg_rate_ratio" size="small" :min="1" :max="100" :precision="0" :step="1">
            </el-input-number>
          </el-form-item>
          <el-form-item label-width="90px" label="订单期限" prop="order_living_time"
                        :rules="[{ required: true, message: '订单期限', trigger: 'blur' }]">
            <el-input-number v-model="form.order_living_time" size="small" :min="1" :max="500" :precision="0" :step="1">
            </el-input-number> 分钟
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="onSubmit()">提交</el-button>
          <el-button @click="disableShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import api from '@/api/api'

const triggerLevel = {
  trigger_mode: 4, // 触发模式
  trigger_price: '', // 触发价格
  order_amount: '15', // 下单金额 单位U
  trigger_rate: 10, // 触发跌幅
  pTriggerPx_rate: 5, // 止盈吃点百分比
  slTriggerPx_rate: 15, // 止损亏点百分比
  is_trigger: 0, // 是否已经触发该级别
  is_enable: true,
  bar: '1H',
  k_limit: 6,
  cur_bar_avg_rate_ratio: 3,
  order_living_time: 60
}

const defaultForm = {
  id: 0,
  instId: '',
  ...triggerLevel
}

export default {
  name: 'TradeConfigSave',
  data () {
    return {
      disableShow: false,
      nowPrice: 1,
      platform: '',
      form: { ...defaultForm },
      instrumentsOpts: [],
      strategyIntroMap: {
        1: {
          name: '抄底策略A',
          desc: `触发条件：
\n1. 下跌
\n2. 当前K线跌幅 > 设置的触发幅度
\n3. 当前K线跌幅，超过前n-1根K线的涨跌幅平均绝对值的x倍(x的值由用户设置)
\n4. 当前价格 < 设置的触发价格
\n5. 可下单张数大于1
\n6. 可下单(is_ordered == true)
推荐K线粒度：4H`
        },
        2: {
          name: '抄底策略B',
          desc: `触发条件：
\n1. 下跌
\n2. 当前K线跌幅 > 设置的触发幅度
\n3. 当前K线跌幅，超过前n-1根K线的涨跌幅绝对值的总和
\n4. 当前价格 < 设置的触发价格
\n5. 可下单张数大于1
\n6. 可下单(is_ordered == true)
推荐K线粒度：1H`
        },
        3: {
          name: '抄底策略C',
          desc: `触发条件：
\n1. 下跌
\n2. 当前K线跌幅 > 设置的触发幅度
\n3. 当前K线下跌幅度，超过之前n-1根K线的涨跌幅度绝对值的总和
\n4. 可下单张数大于1
\n5. 可下单(is_ordered == true)
推荐K线粒度：1H`
        },
        4: {
          name: '超短线做多',
          desc: `触发条件：
\n1. 下跌
\n2. 当前K线跌幅 > 设置的幅度
\n3. 可下单张数大于1
\n4. 可下单(is_ordered == true)
推荐K线粒度：1m`
        }
      },
      rules: {
        coin_name: [
          { required: true, message: '货币名称必填', trigger: 'blur' }
        ],
        instId: [
          { required: true, message: 'instId必填', trigger: 'blur' }
        ],
        is_enable: [
          { required: true, message: '是否启用必填', trigger: 'change' }
        ],
        bar: [
          { required: true, message: 'K线粒度必选', trigger: 'change' }
        ],
        k_limit: [
          { required: true, message: '监控K线数必填', trigger: 'blur' }
        ],
        lever: [
          { required: true, message: '杠杆倍数必填', trigger: 'blur' }
        ],
        cur_bar_avg_rate_ratio: [
          { required: true, message: '触发比率必填', trigger: 'blur' }
        ],
        living_time: [
          { required: true, message: '订单期限必填', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    coinName (instId) {
      return instId.replace('-USDT-SWAP', '')
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$loading({ body: true })
          const params = { ...this.form, ...{ platform: this.platform } }
          api.triggerLevelSave(params).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success({
                message: '操作成功',
                customClass: 'phone-custom-message'
              })
              this.disableShow = false
            } else if (res.code === 20001) {
              this.$message.warning(res.message)
              this.disableShow = false
            } else {
              this.$message.error(res.message)
            }
          }).catch(res => {
            this.$message.error(res)
          }).finally(() => {
            this.$loading({}).close()
            this.$emit('successfn', this.form.instId)
          })
        } else {
          return false
        }
      })
    },
    async show (instId, platform, item) {
      this.platform = platform
      this.$loading({ body: true })
      // 获取可选货币列表
      this.disableShow = true
      if (item) {
        // 编辑回显
        this.form = { ...item }
        this.form.order_living_time /= 60
        this.form.is_enable = this.form.is_enable === 1
      } else {
        // 新建使用默认值
        this.form = { ...defaultForm }
        // 获取可选货币列表
        await api.markPrice({ platform: platform, trade_type: 'future', instId: instId }).then(res => {
          console.log(res)
          this.form.trigger_price = res.data || ''
        }).catch(e => {
          this.form.trigger_price = ''
        })
      }
      this.form.instId = instId
      this.$loading({}).close()
    }
  }
}
</script>

<style scoped>
.tradeConfigForm {
  padding-right: 15px;;
}
.tradeConfigForm .el-form-item {
  margin-bottom: 10px;
}
.trigger-level-form {
  padding-top: 5px;
}
</style>
<style>
.U-append .el-input-group__append {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.phone-custom-message {
  top: 30% !important; /* 垂直居中 */
  left: 50% !important; /* 水平居中 */
  transform: translate(-50%, -50%) !important; /* 偏移修正 */
  width: auto !important; /* 宽度自适应 */
  min-width: 200px; /* 最小宽度 */
  text-align: center; /* 文字居中 */
}
</style>
